package site.shadadman.pages.worklog.SportsGameX

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAug122025SportsGameXMLModelPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/SportsGameX/aug122025SportsGameXMLModel.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/SportsGameX/aug122025-sports-game-xml-model")
@Composable
fun Aug122025SportsGameXMLModelPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("date-sportsgamex-ml-model") }) {
        org.jetbrains.compose.web.dom.Text("date-SportsGameX-ML-Model")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The idea of having a personal assistant tailored to each specific user was truly great. We had an excellent machine learning model capable of running locally directly on the user’s mobile device. This was a major step forward in user experience and would give us a significant advantage over competitors for multiple reasons.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This model will be run directly on mobile devices, so user data security will be greatly enhanced. Nothing will be sent to the server, absolutely nothing.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The model was brilliantly trained by our AI branch and designed to assist users during buy/sell actions. It provides personalized market anomaly alerts. We called it ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("anomaly_detecter")
        }
        org.jetbrains.compose.web.dom.Text(" . This was a tiny model, optimized and converted to ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("tflite")
        }
        org.jetbrains.compose.web.dom.Text(", that runs on the mobile devices. It learns the user’s patterns, such as typical trading times, preferred tickers, and reactions to price movements. Then, it flags unusual events specific to that user, not for the whole market.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We could worn the user with some anomalies. Here are some output from the model when the sport if ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Football")
        }
        org.jetbrains.compose.web.dom.Text(":")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The odds for the home team just moved faster than usual for matches you follow.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Goal chance probability jumped suddenly. this doesn’t happen often in your tracked matches.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Cards and foul rates just increased far quicker than in your usual match profiles")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The under/over line shifted faster than what you typically see.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Running the model itself wasn’t a challenge due to my years of experience. The real difficulty lay in my insistence on using Kotlin Multiplatform KMP to deploy the model and use its output on both Android and iOS platforms. Because I had previously been responsible for a few KMP modules, my proposal didn’t concern our Mobile Head or the Android team, but the iOS team wasn’t particularly happy about it.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The iOS team was woried that if we did not use the apple framework to run our model it may effect on its speed and accurecy, since it needed CPU and CoreML for better result.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I respected their concerns, but it did not make me change my stance. Kotlin Multiplatform was an excellent choice for this situation, as it allows the use of native frameworks to run such a model. They wanted to use CoreML, certainly, I could easily integrate CoreML with KMP. This was not a wrapper, but a typical native implementation that directly uses Apple’s frameworks.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("So, to prove my point, I started two small POC projects. One was a simple image based live detection app that used a tflite model for object detection, and the other was our text based model that relied on the CPU. Both projects used the offical tflite library for iOS under the hood. During several meetings with some of my trusted iOS colleagues, I demonstrated that the underlying code was actually the native Apple framework, with no actual changes in accuracy or performance. The results from my POC were identical to those of a native iOS implementation. In the end, I successfully convinced them to adopt a Kotlin Multiplatform module for this feature.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The challenge was quite satisfying, not only because I finally made my voice heard, but also because I managed to convince an entire iOS team. I was incredibly proud of myself and truly happy. Challenges like this are what make my work the best job in the world. Ohh I love coding so much. I shall mark this success in my work callender.")
    }
}
